import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { debounce } from "lodash";
import {
  FaEnvelope,
  FaPhoneSquare,
  FaUser,
  FaArrowRight,
  FaPray,
  FaRegEnvelopeOpen,
  FaCross,
} from "react-icons/fa";
import {
  Button,
  Form,
  Card,
  ListGroup,
  Row,
  Col,
  Pagination,
  Collapse,
} from "react-bootstrap";
import UtilMethods from "../../util/UtilMethods";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import { useAuth } from "../../auth/AuthContext";
import { cloneDeep } from "lodash";
import {
  PRAYER_REQUEST_CATEGORIES,
  PRAYER_REQUEST_STATUSES,
} from "../common/Constants";
import {
  fetchPrayerRequests,
  updatePrayerReqStatus,
  updatePrayerReq,
} from "../../services/PrayerServices";
import MarianLogo from "../common/MarianLogo"; // Import the MarianLogo component
import menuAdmin from "../../source/menuAdmin.json";
import { Tooltip } from "react-tooltip";
const ListPrayerRequestSummaryPage = () => {
  const { user, logout } = useAuth();
  const [prayerRequests, setPrayerRequests] = useState([]);
  const [initialPrayerRequests, setInitialPrayerRequests] = useState([]);
  const [selectedPrayer, setSelectedPrayer] = useState(null);
  const [expandedMessages, setExpandedMessages] = useState({});
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    status: "Sent to Marian",
    category: "Prayer",
  });
  // Responsive states
  const [isTablet, setIsTablet] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Force update to trigger re-render
  const [forceUpdate, setForceUpdate] = useState(false);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8; // Number of items per page
  const totalPages = useMemo(
    () => Math.ceil(prayerRequests.length / pageSize),
    [prayerRequests.length, pageSize]
  );
  const totalRecords = prayerRequests.length; // or a separate `totalRecords` from API
  const startIndex = (currentPage - 1) * pageSize + 1;
  const endIndex = Math.min(currentPage * pageSize, totalRecords);

  const displayedRequests = prayerRequests.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const [panelWidth, setPanelWidth] = useState(45);
  const [showFilters, setShowFilters] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const dividerRef = useRef(null);
  const containerRef = useRef(null);

  // Handle mouse down event
  const handleMouseDown = (e) => {
    handleStart(e);
  };

  // Start resizing
  const handleStart = (e) => {
    e.preventDefault();
    setIsDragging(true);
    document.body.style.userSelect = "none"; // Prevent text selection
  };

  const handleMove = (e) => {
    let clientX;

    // Detect touch or mouse event
    if (e.type.includes("touch")) {
      clientX = e.touches[0].clientX; // Use touch position
    } else {
      clientX = e.clientX; // Use mouse position
    }

    if (!isDragging) return;

    // Convert clientX to panel width percentage
    const containerWidth = containerRef.current.offsetWidth;
    let newPanelWidth = (clientX / containerWidth) * 100;

    // Restrict panel width within limits
    newPanelWidth = Math.max(20, Math.min(newPanelWidth, 80));
    setPanelWidth(newPanelWidth);
  };

  // End resizing
  const handleEnd = () => {
    setIsDragging(false);
    document.body.style.userSelect = "auto"; // Restore text selection
  };
  // Attach event listeners
  useEffect(() => {
    if (isDragging) {
      document.addEventListener("mousemove", handleMove);
      document.addEventListener("touchmove", handleMove);
      document.addEventListener("mouseup", handleEnd);
      document.addEventListener("touchend", handleEnd);
    } else {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("touchmove", handleMove);
      document.removeEventListener("mouseup", handleEnd);
      document.removeEventListener("touchend", handleEnd);
    }
    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("touchmove", handleMove);
      document.removeEventListener("mouseup", handleEnd);
      document.removeEventListener("touchend", handleEnd);
    };
  }, [isDragging]);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsTablet(window.innerWidth <= 1024 && window.innerWidth >= 768);
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    console.log("menuAdmin", menuAdmin);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    fetchPrayerRequestsData();
  }, [filters]);

  const filterMenuByUserType = (menu, userType) => {
    if (!userType) return []; // Return empty menu if no userType is provided

    const userTypes = new Set(userType.split(",")); // Convert to Set for fast lookup
    //console.log("userTypes", userTypes);

    const filteredMenu = {
      items: [],
    };

    menu.items.forEach((menuItem) => {
      const filteredSubItems = menuItem.subItems
        ? menuItem.subItems.filter((subItem) => {
            if (!subItem.userTypes) return true; // No restriction, show to all
            const allowedUserTypes = new Set(subItem.userTypes.split(","));
            const isVisible = [...userTypes].some((type) =>
              allowedUserTypes.has(type)
            );
            /* console.log(
              `Subitem ${subItem.name} is ${
                isVisible ? "visible" : "hidden"
              } for user types ${userType}`
            );*/
            return isVisible;
          })
        : [];

      if (filteredSubItems.length > 0) {
        filteredMenu.items.push({
          ...menuItem,
          subItems: filteredSubItems,
        });
      }
    });

    return filteredMenu;
  };
  const debouncedFetchPrayerRequests = useCallback(
    debounce(async (filters) => {
      try {
        const data = await fetchPrayerRequests(filters);
        setInitialPrayerRequests(cloneDeep(data));
        setPrayerRequests(data);
        if (data && data.length > 0) {
          setSelectedPrayer({ ...data[0], read: true });
          setPrayerRequests((prevRequests) =>
            prevRequests.map((prayer) =>
              prayer.id === data[0].id ? { ...prayer, read: true } : prayer
            )
          );
        } else {
          setPrayerRequests([]);
          setSelectedPrayer(null);
          setInitialPrayerRequests([]);
        }
      } catch (err) {
        console.error("Error fetching prayer requests", err);
        setPrayerRequests([]);
        setSelectedPrayer(null);
        setInitialPrayerRequests([]);
      }
    }, 300),
    []
  );

  const fetchPrayerRequestsData = useCallback(() => {
    debouncedFetchPrayerRequests(filters);
  }, [filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const findChangedRequests = () => {
    return prayerRequests.filter((current) => {
      const initial = initialPrayerRequests.find((p) => p.id === current.id);
      return (
        initial &&
        (initial.status !== current.status ||
          initial.read !== current.read ||
          initial.messageFromMarian !== current.messageFromMarian)
      );
    });
  };

  useEffect(() => {
    const handleBeforeUnload = async () => {
      const changedRequests = findChangedRequests();
      console.log("Changed Requests:", changedRequests.length);
      if (changedRequests.length > 0) {
        for (const prayer of changedRequests) {
          console.log("Saving changes for prayer request:", prayer.id);
          updatePrayerReq(prayer, user?.userID || "Fr Dominic");
        }
      } else {
        console.log("No changes detected.");
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [prayerRequests, initialPrayerRequests, user]);

  // Toggle message expansion
  const toggleMessageExpansion = (id) => {
    setExpandedMessages((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };
  const handleChangeStatus = async (prayer, newStatus, email) => {
    try {
      if (!user || !user.userID) {
        alert("User is not authenticated.");
        return;
      }
      const actionedBy = user.userID || "Fr Dominic";
      if (!prayer) {
        return;
      }
      if (newStatus === "Forwarded" && !email) {
        const prayerResponse = await updatePrayerReqStatus(
          prayer,
          prayer.status,
          actionedBy
        );
        setPrayerRequests((prevRequests) =>
          prevRequests.map((prayer) =>
            prayer.id === prayerResponse.id
              ? { ...prayer, ...prayerResponse }
              : prayer
          )
        );
        // updating initial set with saved data
        setInitialPrayerRequests((prevRequests) =>
          prevRequests.map((prayer) =>
            prayer.id === prayerResponse.id
              ? { ...prayer, ...prayerResponse }
              : prayer
          )
        );
        //no status change just save remarks and email
      } else {
        // Call API to update the status
        const prayerResponse = await updatePrayerReqStatus(
          prayer,
          newStatus,
          actionedBy
        );
        setPrayerRequests((prevRequests) =>
          prevRequests.map((prayer) =>
            prayer.id === prayerResponse.id
              ? { ...prayer, ...prayerResponse }
              : prayer
          )
        );
        // updating initial set with saved data
        setInitialPrayerRequests((prevRequests) =>
          prevRequests.map((prayer) =>
            prayer.id === prayerResponse.id
              ? { ...prayer, ...prayerResponse }
              : prayer
          )
        );
      }
    } catch (err) {
      console.error("Error updating prayer request status", err);
      alert("Error updating prayer request status");
    }
    //fetchPrayerRequestsData();
  };
  const handlePrayerSelection = async (prayer) => {
    if (selectedPrayer) {
      console.log(
        "handlePrayerSelection current selected prayer:",
        prayer.firstName,
        prayer.lastName,
        "read:",
        prayer.read
      );
      console.log(
        "handlePrayerSelection prev selected prayer:",
        selectedPrayer.firstName,
        selectedPrayer.lastName,
        "read:",
        selectedPrayer.read
      );
      if (selectedPrayer.id !== prayer.id) {
        // check if selected prayer changed
        const initial = initialPrayerRequests.find(
          (p) => p.id === selectedPrayer.id
        );
        console.log(
          "handlePrayerSelection initial prayer:",
          initial?.firstName,
          initial?.lastName,
          "read:",
          initial?.read
        );
        const isChanged =
          initial &&
          (initial.status !== selectedPrayer.status ||
            initial.read !== selectedPrayer.read ||
            initial.messageFromMarian !== selectedPrayer.messageFromMarian);
        console.log("isChanged:", isChanged);
        if (isChanged) {
          const updatedPrayer = await updatePrayerReq(
            selectedPrayer,
            user?.userID || "Fr Dominic"
          );
          console.log(
            "Saved changes for previous prayer request.",
            updatedPrayer
          );
          // setting the current selection as read
          setInitialPrayerRequests((prevRequests) =>
            prevRequests.map((p) =>
              p.id === selectedPrayer.id ? { ...updatedPrayer } : p
            )
          );
        } else {
          console.log("No changes detected for previous prayer request.");
        }
      }
    }
    console.log("Selecting Prayer:", prayer.lastName, prayer.firstName);
    setSelectedPrayer({ ...prayer, read: true });
    // setting the current selection as read
    setPrayerRequests((prevRequests) =>
      prevRequests.map((p) => (p.id === prayer.id ? { ...p, read: true } : p))
    );
  };

  return (
    <div className="container-fluid position-relative p-0" ref={containerRef}>
      {/* Header */}
      <div className="container-fluid p-0 d-flex justify-content-between align-items-center">
        <MarianLogo />
        <h5 className="text-center mb-0">Prayer Requests</h5>
        {/* Button to toggle instructions visibility */}
        <div className="d-flex align-items-center">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setShowFilters((prev) => !prev);
            }}
            className="text-decoration-underline me-3"
            aria-controls="filter-panel"
            aria-expanded={showFilters}
          >
            {showFilters ? " Hide Filters ▲ " : " Show Filters ▼ "}
          </a>

          {user ? (
            <>
              {/* <div className="dropdown">
              <button
                className=" dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Menu
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                {filterMenuByUserType(menuAdmin, user.userType).items.map(
                  (item) =>
                    item.subItems?.map((subItem) => (
                      <li key={subItem.name}>
                        <a
                          className="dropdown-item"
                          href={subItem.link}
                          onClick={() =>
                            document
                              .getElementById("dropdownMenuButton")
                              .click()
                          }
                        >
                          {subItem.name}
                        </a>
                      </li>
                    ))
                )}
              </ul>
            </div>*/}

              <a
                href="/logout"
                className="text-decoration-underline me-2 "
                onClick={(e) => {
                  e.preventDefault();
                  console.log("Logout Menu clicked");
                  logout();
                }}
              >
                Logout
              </a>
            </>
          ) : (
            <a href="/login" className="nav-item nav-link">
              Login
            </a>
          )}
        </div>
      </div>
      {/* Display instructions only if showInstructions is true */}
      <Collapse in={showFilters}>
        <div id="filter-panel" className="mt-2">
          <Form>
            <Row>
              <Col md={3}>
                <Form.Group controlId="fromDate">
                  <Form.Label>From Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={filters.fromDate}
                    onChange={(e) => handleFilterChange(e)}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId="toDate">
                  <Form.Label>To Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={filters.toDate}
                    onChange={(e) => handleFilterChange(e)}
                  />
                </Form.Group>
              </Col>

              <Col md={2}>
                <Form.Group controlId="status">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    as="select"
                    name="status"
                    title="Status"
                    value={filters.status}
                    onChange={(e) => handleFilterChange(e)}
                  >
                    {PRAYER_REQUEST_STATUSES.map((status) => (
                      <option key={status.value} value={status.value}>
                        {status.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group controlId="category">
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    as="select"
                    name="category"
                    value={filters.category}
                    onChange={(e) => handleFilterChange(e)}
                    title="Category"
                  >
                    <option value="">All</option>
                    {PRAYER_REQUEST_CATEGORIES.map((category) => (
                      <option key={category.value} value={category.value}>
                        {category.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={1} className="d-flex align-items-end">
                <Button
                  variant="primary"
                  onClick={() => fetchPrayerRequestsData()}
                >
                  List
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Collapse>
      <Row
        className="mt-1 g-0"
        style={{
          display: "flex",
          flexWrap: "nowrap",
          maxHeight: isMobile ? "60vh" : "80vh",
        }}
      >
        {/* Left Panel: Prayer List */}
        <Col
          style={{
            flex: `${panelWidth}%`,
            maxHeight: isMobile ? "60vh" : "80vh",
            overflowY: "auto",
            transition: isDragging ? "none" : "0.2s ease",
          }}
          className="border-end px-2"
        >
          <ListGroup className="pt-2">
            {displayedRequests.length === 0 ? (
              <ListGroup.Item className="text-center py-3">
                No pending prayer requests.
              </ListGroup.Item>
            ) : (
              displayedRequests.map((prayer) => (
                <ListGroup.Item
                  key={prayer.id}
                  action
                  onClick={() => handlePrayerSelection(prayer)}
                  className={`position-relative d-flex justify-content-between align-items-start p-2 ${
                    selectedPrayer?.id === prayer.id ? "active" : ""
                  } ${prayer.read ? "text-muted" : ""}`}
                >
                  <div className="pe-5">
                    <div className="d-flex align-items-center mb-1">
                      <FaUser className="me-2" />
                      <span
                        style={{ fontWeight: prayer.read ? "normal" : "bold" }}
                      >
                        {prayer.firstName} {prayer.lastName}
                      </span>
                      <span
                        className="ms-2"
                        style={{
                          color:
                            prayer.status === "Blessed" ? "green" : "inherit",
                          fontWeight:
                            prayer.status === "Blessed" ? "bold" : "normal",
                        }}
                      >
                        ({prayer.status})
                      </span>
                    </div>
                    <div className="small text-wrap">
                      <FaPray className="me-1" />
                      {prayer.summary || "No summary provided."}
                    </div>
                  </div>

                  <div className="position-absolute top-0 end-0 mt-2 me-2 d-flex flex-column align-items-end">
                    <div className="d-flex align-items-center mb-1">
                      <span className="text-muted small">
                        {UtilMethods.formatDateTimeDDMMYY(
                          prayer.createdAt
                        ).trim()}
                      </span>
                      {prayer.read ? (
                        <FaRegEnvelopeOpen className="text-success ms-2" />
                      ) : (
                        <FaEnvelope className="text-warning ms-2" />
                      )}
                      <FaArrowRight className="ms-1" />
                    </div>
                    <a
                      href="#"
                      className="btn btn-sm btn-primary"
                      onClick={(e) => {
                        e.preventDefault();
                        handleChangeStatus(prayer, "Blessed", null);
                      }}
                      aria-label="Bless Prayer"
                    >
                      <FaCross className="me-1" /> Bless{" "}
                      <FaCross className="me-1" />
                    </a>
                  </div>
                </ListGroup.Item>
              ))
            )}
          </ListGroup>

          {/* Pagination and Bless All */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mt-2 px-2">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <small className="text-muted ms-2 me-2">
                {startIndex}–{endIndex} of {totalRecords} 
              </small>

              <Pagination size="sm" className="mb-0 me-2">
                <Pagination.First
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(1)}
                />
                <Pagination.Prev
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                />
                {[...Array(totalPages)].map((_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                />
                <Pagination.Last
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(totalPages)}
                />
              </Pagination>
            </div>

            {displayedRequests.length > 0 && (
              <a
                className="btn btn-sm btn-primary mb-2"
                onClick={async () => {
                  for (const prayer of displayedRequests) {
                    await handleChangeStatus(prayer, "Blessed", null);
                  }
                  setCurrentPage((prevPage) =>
                    Math.min(prevPage + 1, totalPages)
                  );
                }}
                disabled={displayedRequests.length <= 0}
              >
                <FaCross className="me-1" /> Bless All{" "}
                <FaCross className="me-1" />
              </a>
            )}
          </div>
        </Col>

        {/* Draggable Divider */}
        <div
          ref={dividerRef}
          onMouseDown={handleMouseDown}
          onTouchStart={(e) => handleMouseDown(e)}
          style={{
            cursor: "col-resize",
            width: "10px", // Increased width for better touch area
            maxHeight: isMobile ? "60vh" : "80vh",
            backgroundColor: isDragging ? "#888" : "#ccc",
            transition: "background-color 0.2s",
            position: "relative",
            zIndex: 10,
            marginLeft: "-5px", // Center the divider
          }}
        />

        {/* Right Panel: Selected Prayer */}
        {(!isMobile || selectedPrayer) && (
          <Col
            style={{
              flex: `${100 - panelWidth}%`,
              maxHeight: isMobile ? "60vh" : "80vh",
              overflowY: "auto",
              transition: isDragging ? "none" : "0.2s ease",
            }}
          >
            {selectedPrayer ? (
              <Card className="p-4 shadow-sm">
                <Card.Title>
                  <FaUser className="me-2" /> {selectedPrayer.firstName}{" "}
                  {selectedPrayer.lastName}
                </Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                  <a href={`mailto:${selectedPrayer.email}`}>
                    <FaEnvelope className="me-1" /> {selectedPrayer.email}
                  </a>{" "}
                  <a href={`tel:${selectedPrayer.phone}`}>
                    <FaPhoneSquare className="me-1" /> {selectedPrayer.phone}
                  </a>
                </Card.Subtitle>
                <Card.Body>
                  <Card.Text>
                    <strong>Summary:</strong>{" "}
                    {selectedPrayer.summary || "No summary provided."}
                  </Card.Text>
                  <Card.Text>
                    <strong>Prayer Request:</strong>{" "}
                    {selectedPrayer.messageInEnglish}
                    {selectedPrayer.id &&
                      selectedPrayer.language &&
                      selectedPrayer.language !== "en" &&
                      selectedPrayer.language !== "ml" && (
                        <span>
                          <Button
                            variant="link"
                            onClick={() =>
                              toggleMessageExpansion(
                                `original-${selectedPrayer.id}`
                              )
                            }
                          >
                            {expandedMessages[`original-${selectedPrayer.id}`]
                              ? `Hide ${selectedPrayer.language.toUpperCase()}`
                              : `Show ${selectedPrayer.language.toUpperCase()}`}
                          </Button>
                          {expandedMessages[
                            `original-${selectedPrayer.id}`
                          ] && (
                            <Card.Text className="mt-2">
                              {selectedPrayer.message}
                            </Card.Text>
                          )}
                        </span>
                      )}
                  </Card.Text>
                  <Card.Text className="text-break">
                    <strong>Prayer Reply:</strong>{" "}
                    {selectedPrayer.replyMessage || "No reply yet."}
                  </Card.Text>
                  <Form.Group>
                    <Form.Label>
                      <strong>Reply from Marian:</strong>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter reply message..."
                      value={selectedPrayer.messageFromMarian || ""}
                      onChange={(e) => {
                        const updatedPrayer = {
                          ...selectedPrayer,
                          messageFromMarian: e.target.value,
                          read: true,
                        };
                        setSelectedPrayer(updatedPrayer);
                        setPrayerRequests((prevRequests) =>
                          prevRequests.map((prayer) =>
                            prayer.id === selectedPrayer.id
                              ? updatedPrayer
                              : prayer
                          )
                        );
                      }}
                    />
                  </Form.Group>
                  <a
                    className="btn btn-primary mb-1"
                    onClick={() =>
                      handleChangeStatus(selectedPrayer, "Blessed", null)
                    }
                    data-tooltip-id="blessTooltip"
                  >
                    <FaCross className="me-1" />
                    <Tooltip
                      id="blessTooltip"
                      place="bottom"
                      content="Click after blessing the prayer request"
                      openOnClick={false} // Ensure it does not need a click to open
                      delayShow={200} // Small delay for better UX
                      delayHide={300} // Delay hiding for better touch handling
                      events={["hover", "touchstart"]} // Enable hover and touch for mobile
                    />
                    Bless <FaCross className="me-1" />
                  </a>
                  {isMobile && selectedPrayer && (
                    <Button
                      className="mb-2"
                      onClick={() => setSelectedPrayer(null)}
                    >
                      ← Back to List
                    </Button>
                  )}
                </Card.Body>
              </Card>
            ) : (
              <p className="text-center">
                Select a prayer request to view details.
              </p>
            )}
          </Col>
        )}
      </Row>
    </div>
  );
};

export default ListPrayerRequestSummaryPage;
